import { render, staticRenderFns } from "./LeaveOfAbsenceTab.vue?vue&type=template&id=77eabf28"
import script from "./LeaveOfAbsenceTab.vue?vue&type=script&lang=js"
export * from "./LeaveOfAbsenceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports